import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import BannerPopup from "../banner/BannerPopup";
import BannerReminder from "../banner/BannerReminder";
import PageLoader from "./PageLoader";
import PublicScrollToTop from "./PublicScrollToTop";

// Navbar / BannerPopup / Footer sirf ek baar mount hote hain.
// Page change par sirf <Outlet /> badalta hai.
const PublicLayout = () => (
  <>
    <PublicScrollToTop />
    <Navbar />
    <BannerPopup />
    <BannerReminder />
    <Suspense fallback={<PageLoader />}>
      <Outlet />
    </Suspense>
    <Footer />
  </>
);

export default PublicLayout;
